export const apiName: string = 'Seguros';
export const segurosRoute: string = 'seguros';
export const segurosStorage: string = 'seguros';
export const segurosModuleName: any = {plural: 'Seguros', single: 'Seguro'};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguros/shared/data.service.ts
 **/